import { render, staticRenderFns } from "./MarcaList.vue?vue&type=template&id=0ac8f6f1&scoped=true&"
import script from "./MarcaList.vue?vue&type=script&lang=js&"
export * from "./MarcaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac8f6f1",
  null
  
)

export default component.exports